import notify from '@patientpattern/coat/ui/Notification';
import {QueryClient} from '@tanstack/react-query';

/* istanbul ignore next */
function onError(error: unknown) {
    // check for request errors array and if not available use default axios error
    // @ts-ignore: Not sure how to type this since react-query uses an unknown generic here too
    // eslint-disable-next-line
    const errors = error?.response?.data?.errors || [error];

    notify({
        title: 'Error',
        variant: 'error',
        // eslint-disable-next-line
        message: errors.map(({message}: {message: string}, i: number) => (
            <p key={i}>{message ?? 'An error occurred. Please try again.'}</p>
        )),
    });
}

const queryClient = new QueryClient({
    defaultOptions: {
        mutations: {
            onError,
        },
        queries: {
            onError,
            refetchOnWindowFocus: false,
        },
    },
});

export default queryClient;
